import {Component, OnInit, Input, ViewChild, AfterViewInit} from '@angular/core';
import {NgForm} from '@angular/forms';

@Component({
    selector: 'app-payroll-time',
    templateUrl: './payroll-time.component.html',
    styleUrls: ['./payroll-time.component.css']
})
export class PayrollTimeComponent implements OnInit, AfterViewInit {
    @Input() payrollInvoice;
    @Input() index;
    @Input() isClient = false;
    @ViewChild('payrollTimeFields') public form: NgForm;
    @Input() parentForm: NgForm;
    @Input() isReadOnly = false;
    interpTimePlaceHolder = '';
    prepTimePlaceHolder = '';
    kmPlaceHolder = '';
    travelTimePlaceHolder = '';
    isNG = false;
    isWKN = false;

    constructor() {
    }

    ngAfterViewInit() {
        if (this.parentForm !== null) {
            let ctrlName = 'timeFields_' + (this.isClient ? 'client_' : 'interpreter_') + this.index;

            if (!this.parentForm.form.contains(ctrlName)) {
                this.parentForm.form.addControl(ctrlName, this.form.form);
            }
        }
    }

    ngOnInit() {
        this.interpTimePlaceHolder = this.payrollInvoice.recommended.interpreting_time;
        this.prepTimePlaceHolder = this.payrollInvoice.preparation_time;
        this.kmPlaceHolder = this.payrollInvoice.recommended.distance;
        this.travelTimePlaceHolder = this.payrollInvoice.recommended.travel_time;
        this.isTimeNGOrWKN(this.payrollInvoice.interpreting_time_night, this.payrollInvoice.interpreting_time_weekend);
    }

    isTimeNGOrWKN(timeNG: string, timeWKN: string) {
        let durationNG;
        let durationWKN;
        durationNG = timeNG.split(':');
        durationWKN = timeWKN.split(':');
        this.isNG = (Boolean(durationNG[0]) && durationNG[0] > 0) || (Boolean(durationNG[1]) && durationNG[1] > 0);
        this.isWKN = (Boolean(durationWKN[0]) && durationWKN[0] > 0) || (Boolean(durationWKN[1]) && durationWKN[1] > 0);
    }
}



// WEBPACK FOOTER //
// ./src/app/booking-management/payroll-time/payroll-time.component.ts